import Journeys from './Journeys.component';

export default Journeys;
